import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import Edit from 'appSrc/components/Icons/Edit';
import { dAPI } from 'appSrc/api';
import { PrimaryButton, DLRichTextEditor, Checkbox } from 'appSrc/components/UI';
import { FormTextField, FormToggle, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import { DLTextField } from 'appSrc/components/UI';
import coverImgSample from 'appSrc/assets/img/16x9_sample.png';
import style from './styles/style.module.css';
import { convertYouTubeIdToImg, parseYouTubeUrl } from 'appSrc/utils';


class VideoForm extends PureComponent {

    constructor( props ) {
        super( props );

        this.youtubeId = props.initialValues.youtubeId;

        this.state = {
            selectedImage: props.initialValues.coverImage,
            useTYThumb: /^https:\/\/img.youtube.com/.test( props.initialValues.coverImage ),
            description: props.initialValues.description,
            searchValue: '',
            showResults: false,
            open: true,
            canClose: true,
            url: props.initialValues.youtubeUrl,
        };
    }
    updateTags = ( tags ) => {
        this.setState( { tags } );
        this.props.changeFieldValue( 'tags', tags );
    }
    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'image', imageData );
        }
    }
    updateUrl = ( e ) => {
        let value = e.target.value;
        let youtubeId = parseYouTubeUrl( value );
        if( youtubeId !== null ) {
            this.youtubeId = youtubeId;
        }
        this.setState( { url: value  } );
    }
    updateDescription = ( value ) => {
        this.setState( { description: value } );
        this.props.changeFieldValue( 'description', value );
    }
    catchKeyPress = ( e ) => {
        if( e.key == 'Enter' ) {
            e.preventDefault();
        }
    }
    submitHandler = ( values ) => {
        var updates = { ...values };
        updates.coverImage = this.state.selectedImage;
        updates.youtubeUrl = this.state.url;
        updates.youtubeId = this.youtubeId;
        this.props.onSubmit( updates );
    }
    updateUseThumb = ( e, value ) => {
        this.regressionCount = 0;
        this.setState( { useTYThumb: value, selectedImage: null } );
        if( value ) {
            this.setState( { selectedImage: convertYouTubeIdToImg( this.youtubeId, 'jpg' ), quality: 'high' } );
        } else {
            this.setState( { selectedImage: this.props.initialValues.coverImage } );
        }
    }
    checkCoverImage = ( e ) => {
        if( ( this.regressionCount < 2 ) && e.target.naturalHeight <= 90 ) {
            ++this.regressionCount;
            switch ( this.regressionCount ) {
                case 1:
                    this.setState( {
                        selectedImage: convertYouTubeIdToImg( this.youtubeId, 'med/jpg' ),
                    } );
                    break;
                case 2:
                    this.setState( {
                        selectedImage: convertYouTubeIdToImg( this.youtubeId, 'small/jpg' ),
                    } );
                    break;
                default:
                    this.regressionCount = 3;
                    break;
            }
        }
    }
    
    render() {
        const { handleSubmit } = this.props;
        const { selectedImage, useTYThumb } = this.state;



        return (
            <Form
            className={ style.form }
            onSubmit={ handleSubmit( this.submitHandler ) }>
                <div className={ style.topLevel }>
                    <div className={ style.detailsWrapper }>
                        <DLTextField
                        id="url"
                        name="url"
                        label="YouTube URL"
                        value={ this.state.url }
                        fullWidth
                        onChange={ this.updateUrl }/>

                        <div className={ style.imageWrapper }>
                            Cover Image:
                            <ImageCropModalWrapper
                            className={ style.cropper }
                            aspectRatio={ 16/9 }
                            onFinish={ this.cropFinish }>
                                <div>
                                    <img src={ selectedImage || coverImgSample }
                                    onLoad={ useTYThumb ? this.checkCoverImage : () => {} } />
                                    <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } /></span>
                                </div>
                            </ImageCropModalWrapper>

                            <Checkbox label='Use YouTube Thumbnail?'
                            checked={ useTYThumb }
                            onChange={ this.updateUseThumb }
                            // disabled={ youtubeLink == '' || !linkValid }
                            style={ { paddingLeft: '8px', marginTop: '5px' } } />
                            <br/>
                        </div>

                        <Field
                        id="title"
                        name="title"
                        label="Title"
                        component={ FormTextField }
                        fullWidth />

                        <DLRichTextEditor label="Description"
                        value={ this.state.description } onChange={ this.updateDescription } />

                        <Field
                        id="shortDescription"
                        name="shortDescription"
                        label="Short Description"
                        component={ FormTextArea }
                        fullWidth
                        style={ { marginTop: '15px' } } />

                        <Field
                        id='isSponsored'
                        name='isSponsored'
                        label='Sponsored Content?'
                        component={ FormToggle }
                        style={ { marginTop: '15px' } } />

                        <PrimaryButton
                        label="Submit"
                        fullWidth
                        type="submit"
                        style={ { marginTop: '45px' } }/>
                    </div>
                </div>
            </Form>
        );
    }
}

VideoForm = reduxForm( {
    form: 'VideoForm',
} )( VideoForm );

const mapStateToProps = ( state ) => {
    return {
        listInterests: state.vars.interests,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'VideoForm', field, value ) );

        },
        addTag: ( productid, newTag ) => {
            return dAPI.post( `/desires/${ productid }/tag`, { tag: newTag } );

        },
        deleteTag: ( productid, tagtext ) => {
            return dAPI.delete( `/desires/${ productid }/tag/${ tagtext }` );

        },
        findAdvertiser: ( domain ) => {
            return dAPI.post( '/affiliates/advrtsr/search', { domain } );

        },
        getSubAffiliateCode: ( affiliateid ) => {
            return dAPI.get( `/affiliates/subaffiliateID/${ affiliateid }` )
            .catch( () => ( { subAffCode: null } ) );

        },
        getBrands: ( queryObject ) => {
            return dAPI.get( '/admin/brands', queryObject );

        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( VideoForm );
